export const publish = (name, data) => {
  if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS) {
    window.LIFE_CYCLE_EVENT_BUS.trigger(`product-results.${name}`, data);
  }
};

export const publishSponsoredContent = (
  requestedProductCount,
  renderedProductCount,
  requestedSponsoredProductCount,
  renderedSponsoredProductCount
) => {
  if (window.newrelic && typeof LIFE_CYCLE_EVENT_BUS !== 'undefined') {
    window.LIFE_CYCLE_EVENT_BUS.trigger('product-results.render-rate', {
      requestedProductCount,
      renderedProductCount,
      requestedSponsoredProductCount,
      renderedSponsoredProductCount
    });
  }
};
